import { Quotes } from 'types'

export const getCardQuote = (quotes?: Quotes, quoteId?: string) => {
  return quoteId && quotes && quotes[quoteId]
    ? `${quoteId.replace('_', '.')} "${quotes[quoteId]}"`
    : ''
}
